module.exports = __webpack_public_path__ + "static/assets/afb753279098486ca27e29f795bff817.svg";